
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 113.015 113.015"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFDE17"}},[_c('path',{attrs:{"d":"M0 90.412L90.412 0l22.602 22.603-90.411 90.411z"}}),_c('path',{attrs:{"d":"M90.412 113.015L0 22.603 22.603.001l90.411 90.411z"}})])])
          )
        }
      }
    